// extracted by mini-css-extract-plugin
export var fileUpload = "_de-1";
export var modalButton = "_de-0";